import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ProductType } from '@chegg/pricing-sdk';
export var ProductFamily = /*#__PURE__*/function (ProductFamily) {
  ProductFamily["EASYBIB"] = "EASYBIB";
  ProductFamily["CHEGG_STUDY"] = "CHEGG_STUDY";
  ProductFamily["CHEGG_MATH"] = "CHEGG_MATH";
  ProductFamily["BUNDLE"] = "BUNDLE";
  ProductFamily["CENGAGE_UNLIMITED"] = "CENGAGE_UNLIMITED";
  ProductFamily["MHE_BUNDLE"] = "MHE_BUNDLE";
  ProductFamily["PROMOTIONS"] = "PROMOTIONS";
  return ProductFamily;
}({});
export var ConversionType = /*#__PURE__*/function (ConversionType) {
  ConversionType["SINGLE_ITEM_PURCHASE"] = "SINGLE_ITEM_PURCHASE";
  ConversionType["MIXED"] = "MIXED";
  ConversionType["ORDER_EXTPURCHASE"] = "POST_ORDER_EXTPURCHASE";
  ConversionType["CHEGG_API"] = "CHEGG_API";
  ConversionType["CHEGG_API_POST_ORDER_EXTPURCHASE"] = "CHEGG_API_POST_ORDER_EXTPURCHASE";
  ConversionType["TEXTBOOK"] = "TEXTBOOK";
  return ConversionType;
}({});
export var Environment = /*#__PURE__*/function (Environment) {
  Environment["DEVELOPMENT"] = "development";
  Environment["TEST"] = "test";
  Environment["STAGING"] = "staging";
  Environment["PRODUCTION"] = "production";
  return Environment;
}({});

// useful for storybook dropdown
export var ExternalIdMap = /*#__PURE__*/function (ExternalIdMap) {
  ExternalIdMap["Chegg Study V1 No Free Trial"] = "SCP-3";
  ExternalIdMap["Chegg Study V2 No Free Trial"] = "CHGMnthCSV2NFT";
  ExternalIdMap["Chegg Study CAD"] = "CHGMnthCSNFTCAD";
  ExternalIdMap["Chegg Study AUD"] = "CHGMnthCSNFTAUD";
  ExternalIdMap["Chegg Study GBP"] = "CHGMnthCSNFTUK";
  ExternalIdMap["Chegg Study SGD"] = "CHGMnthCSNFTSG";
  ExternalIdMap["Chegg Study RMB"] = "CHGMnthCSNFTCN";
  ExternalIdMap["Chegg Study INR"] = "CHGMnthCSNFTIND";
  ExternalIdMap["Chegg Math Solver"] = "MATH_SUB_MONTHLY";
  ExternalIdMap["Chegg Study Pack"] = "CHGStudyPcknoFT";
  ExternalIdMap["Chegg Study Pack Live"] = "CHGMnthPremiumPackNFT";
  return ExternalIdMap;
}({});
export var ERROR_LOGGING_KEY = 'CHECKOUT_COMPONENT_ERROR';
export var Components = /*#__PURE__*/function (Components) {
  Components["BILLING_DETAILS"] = "Billing Details";
  Components["COUPON"] = "Coupon";
  Components["CTA"] = "CTA";
  Components["DEVICE_POLICY"] = "Device Policy";
  Components["VALUE_PROPS"] = "Value Props";
  Components["SUBSCRIPTION_INFO"] = "Subscription Info";
  Components["TAX"] = "Tax";
  Components["INTERSTITIAL"] = "Interstitial";
  Components["TERMS_AND_CONDITIONS"] = "Terms and Conditions";
  Components["ONE_CLICK"] = "One Click";
  Components["ONE_CLICK_SUBSCRIBE"] = "One Click Subscribe";
  Components["ONE_CLICK_RESUBSCRIBE"] = "One click Resubscribe";
  Components["ONE_CLICK_UPGRADE"] = "One Click Upgrade";
  Components["RESUME_SUBSCRIPTION"] = "Resume Subscription";
  Components["RESTART_SUBSCRIPTION"] = "Restart Subscription";
  Components["RECAPTCHA"] = "Recaptcha";
  Components["ZIPCODE"] = "Zip Code Shown in User Address Component";
  Components["USER_ADDRESS"] = "User Address Component Loaded";
  Components["ZIP_MANDATORY_SHOWN"] = "Mandatory Zip Code Shown in User Address Component";
  Components["ZIP_OPTIONAL_SHOWN"] = "Optional Zip Code Shown in User Address Component";
  Components["ORDER_SUMMARY"] = "Order Summary";
  Components["REVIEW_STEP"] = "Review Step";
  return Components;
}({});
export var BillingCycle = /*#__PURE__*/function (BillingCycle) {
  BillingCycle["MONTHLY"] = "P1M";
  BillingCycle["SEMI_ANNUAL"] = "P6M";
  BillingCycle["ANNUAL"] = "P12M";
  return BillingCycle;
}({});
export var BillingCycleContentKey = /*#__PURE__*/function (BillingCycleContentKey) {
  BillingCycleContentKey["MONTHLY"] = "monthly";
  BillingCycleContentKey["SEMI_ANNUAL"] = "semiAnnual";
  BillingCycleContentKey["ANNUAL"] = "annual";
  return BillingCycleContentKey;
}({});
export var SubscriptionType = /*#__PURE__*/function (SubscriptionType) {
  SubscriptionType["EBOOK_SUB"] = "EBOOK_SUB";
  SubscriptionType["CHEGG_STUDY"] = "CS_SUB";
  SubscriptionType["CHEGG_STUDY_V2"] = "CS_SUB_V2";
  SubscriptionType["CHEGG_STUDY_6_MONTH"] = "CS_SUB_6_MONTH";
  SubscriptionType["CHEGG_STUDY_12_MONTH"] = "CS_SUB_12_MONTH";
  SubscriptionType["CHEGG_STUDY_PACK"] = "CSP_SUB";
  SubscriptionType["NON_SUBSCRIBER"] = "NON_SUBSCRIBER";
  SubscriptionType["CHEGG_MATH"] = "MATH_SUB";
  SubscriptionType["CHEGG_WRITING"] = "EB_SUB";
  return SubscriptionType;
}({});
export var SubscriptionItemType = /*#__PURE__*/function (SubscriptionItemType) {
  SubscriptionItemType["RECURRING_BUNDLE_ITEM"] = "RECURRING_BUNDLE_ITEM";
  SubscriptionItemType["FIXED_RECURRING_ITEM"] = "FIXED_RECURRING_ITEM";
  SubscriptionItemType["SUBSCRIPTION"] = "SUBSCRIPTION";
  SubscriptionItemType["ONE_TIME_ITEM"] = "ONE_TIME_ITEM";
  SubscriptionItemType["ONE_TIME_BUNDLE_ITEM"] = "ONE_TIME_BUNDLE_ITEM";
  return SubscriptionItemType;
}({});
export var Products = /*#__PURE__*/function (Products) {
  Products["CS"] = "cs";
  Products["CSP"] = "csp";
  return Products;
}({});
export var MyOrdersStatus = /*#__PURE__*/function (MyOrdersStatus) {
  MyOrdersStatus["active"] = "active";
  MyOrdersStatus["cancelled"] = "cancelled";
  MyOrdersStatus["expired"] = "expired";
  MyOrdersStatus["paused"] = "paused";
  MyOrdersStatus["pendingCancel"] = "pendingCancel";
  MyOrdersStatus["pendingPause"] = "pendingPause";
  return MyOrdersStatus;
}({});
export var ErrorLocations = /*#__PURE__*/function (ErrorLocations) {
  ErrorLocations["RECURLY_PREVIEW_PURCHASE"] = "Recurly previewPurchase";
  ErrorLocations["QUERY_CACHED_COUPON"] = "GET_SUBSCRIPTION_AUTO_APPLY_COUPON_CACHE query";
  return ErrorLocations;
}({});
export var OfferId = /*#__PURE__*/function (OfferId) {
  OfferId["CS_SUB"] = "CS_SUB";
  OfferId["CS_SUB_V2"] = "CS_SUB_V2";
  OfferId["EB_SUB"] = "EB_SUB";
  OfferId["MATH_SUB"] = "MATH_SUB";
  return OfferId;
}({});
export var PRODUCT_TYPE_TO_OFFER_ID = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ProductType.CHEGG_MATH, [OfferId.MATH_SUB]), ProductType.CHEGG_STUDY, [OfferId.CS_SUB_V2]), ProductType.CHEGG_STUDY_PACK, [OfferId.CS_SUB, OfferId.EB_SUB, OfferId.MATH_SUB]), ProductType.WRITING_TOOLS, [OfferId.EB_SUB]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/common/interfaces.js
// module id = 43
// module chunks = 11